import { useState } from "react";

import infraImg from "../assets/image/cps 001.jpg";
import g1 from "../assets/image/i1.jpeg";
import g2 from "../assets/image/i2.jpeg";
import g3 from "../assets/image/i3.jpeg";
import g4 from "../assets/image/i4.jpeg";
import g5 from "../assets/image/i5.jpeg";

function Infrastructure() {
  const [selected, setSelected] = useState(null);

  const gallery = [g1, g2, g3, g4, g5];

  const highlights = [
    "Campus planned across 2 acres",
    "Located within 3 km from city bus stand",
    "Holistic learning environment",
    "Covers Pre-Primary & Primary education",
    "Modern, technology-driven campus design",
    "State-of-the-art multipurpose hall",
    "Swimming pool within campus",
    "Ergonomic furniture for all age groups",
    "Indoor sports facilities",
    "Special activity rooms",
    "Music, Art & Craft rooms",
    "Smart boards in every classroom",
    "Advanced administrative facilities",
    "Full campus CCTV surveillance",
  ];

  return (
    <section className="py-16 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">

        {/* Title */}
        <h1 className="text-4xl font-bold text-blue-900 mb-10 text-center">
          Infrastructure
        </h1>

        {/* Banner */}
        <div className="rounded-2xl overflow-hidden shadow-lg mb-12">
          <img
            src={infraImg}
            alt="campus"
            className="w-full h-[400px] object-cover"
          />
        </div>

        {/* Highlights */}
        <h2 className="text-2xl font-bold text-yellow-500 mb-6">
          Highlights of Our Campus
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {highlights.map((item, index) => (
            <div key={index} className="bg-white p-5 rounded-xl shadow hover:shadow-lg">
              {item}
            </div>
          ))}
        </div>

        {/* 🔥 Gallery Section */}
        <h2 className="text-2xl font-bold text-yellow-500 mb-6">
          Campus Gallery
        </h2>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6">
          {gallery.map((img, index) => (
            <div
              key={index}
              className="overflow-hidden rounded-xl cursor-pointer group"
              onClick={() => setSelected(img)}
            >
              <img
                src={img}
                alt="gallery"
                className="w-full h-[220px] object-cover group-hover:scale-110 transition duration-300"
              />
            </div>
          ))}
        </div>

        {/* 🔥 Lightbox (popup) */}
        {selected && (
          <div
            className="fixed inset-0 bg-black/80 flex items-center justify-center z-50"
            onClick={() => setSelected(null)}
          >
            <img
              src={selected}
              alt="preview"
              className="max-w-[90%] max-h-[90%] rounded-xl shadow-lg"
            />
          </div>
        )}

      </div>
    </section>
  );
}

export default Infrastructure;